
import React from "react";
import {
  Box,
  SimpleGrid,
  Stat,
  StatLabel,
  StatNumber,
  useColorModeValue,
  Heading,
  HStack,
  VStack,
  Text,
  Badge,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
} from "recharts";



/* ======================================== */
/* 3.  CAMPAIGN PERFORMANCE (shared)        */
/* ======================================== */
export const CampaignPerformance = () => {
  const data = [
    { name: "Spring Sale", clicks: 1200, conv: 320 },
    { name: "Diwali Blast", clicks: 980, conv: 280 },
    { name: "Clearance", clicks: 750, conv: 190 },
  ];
  const bg = useColorModeValue("white", "gray.800");
  const border = useColorModeValue("gray.100", "gray.700");
  return (
    <Box p={6} bg={bg} rounded="xl" border="1px" borderColor={border} shadow="sm">
      <Heading as="h3" size="md" mb={4}>
        Campaign Performance
      </Heading>
      <Box h="260px">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} layout="vertical" margin={{ left: 40 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis type="number" />
            <YAxis dataKey="name" type="category" />
            <Tooltip />
            <Bar dataKey="clicks" fill="#8b5cf6" />
            <Bar dataKey="conv" fill="#06b6d4" />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
};